import { render } from "./Allowance.vue?vue&type=template&id=5fff26b2&scoped=true"
import script from "./Allowance.vue?vue&type=script&lang=js"
export * from "./Allowance.vue?vue&type=script&lang=js"

import "./Allowance.vue?vue&type=style&index=0&id=5fff26b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fff26b2"]])

export default __exports__